<template>
  <v-card>
    <v-card-title class="pb-0" v-if="show_load_more">
      <v-flex class="pl-8" sm4>
        <v-autocomplete
            :items="actions"
            @change="getData"
            clearable
            flat
            item-text="name"
            item-value="key"
            label="Filter by Action Types"
            outlined
            solo
            multiple
            chips
            deletable-chips
            v-model="filters.type"
        />
      </v-flex>
      <v-flex sm4>
        <v-autocomplete
            :items="years"
            @change="getData"
            class="ml-2"
            clearable
            flat
            label="Filter by Visa Year"
            outlined
            solo
            v-model="filters.year"
        />
      </v-flex>
    </v-card-title>
    <v-card-text class="py-0">
      <v-timeline align-top dense>
        <v-timeline-item
            :color="getStatusColor(item.statusNumber)"
            :icon="getIcon(item.statusNumber)"
            :key="i"
            fill-dot1
            v-for="(item, i) in history"
            v-if="item.status && (!item.deleted_at || !hideDeletedStatus.includes(item.status))"
        >
          <v-layout pt-1>
            <v-flex xs5 class="d-flex">
              <h4 class="timeline-title-blue" v-if="item.statusNumber===1">
                {{ getPaymentSideText(item) }}</h4>
              <h4 class="timeline-title-blue" v-else>{{ getStatusName(item.statusNumber) }}</h4>
              <span class="mx-2" style="font-size: 11px;">at</span>
              <h5 class="timeline-date ">{{ item.created_at }}</h5>
            </v-flex>
            <v-flex xs7>
              <div class="d-flex">
                <h4 class="timeline-title-blue" v-if="item.user && item.user.name">
                  {{
                    item.extra ? item.extra.user ? item.extra.user.name : item.user ? item.user.name ? item.user.name : "" : "" : ""
                  }}</h4>
                <!--                                {{item.extra}}-->
                <h3 class="timeline-title-black" style="font-size: 13px;margin-left: 3px;"
                    v-if="(item.statusNumber != 21 && item.statusNumber != 22 && item.statusNumber != 23 && item.statusNumber != 49) && item.extra && item.extra.office">
                  ({{ item.extra.office }})
                </h3>
                <v-spacer></v-spacer>
                <v-btn
                    @click="view(item.visa.submission_no)"
                    class="float-right"
                    color="primary"
                    dark
                    dense
                    text
                    v-if="show_load_more && item.visa"
                    x-small>
                  View Visa Details
                </v-btn>
                <v-btn
                    @click="viewSCP(item)"
                    class="float-right"
                    color="primary"
                    dark
                    dense
                    text
                    v-if="(item.statusNumber === 66 || item.statusNumber === 67) && !item.deleted_at"
                    x-small>
                  View SCP Details
                </v-btn>
                <v-tooltip
                    top
                    v-if="!item.deleted_at && !paid && item.statusNumber === 48 && item.extra && item.extra.voucher_number"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                        @click="testIPayment(item)"
                        class="ml-2"
                        color="orange lighten-1"
                        dark
                        dense
                        fab
                        v-on="on"
                        x-small
                        v-if="$oauth.checkIfHasPermission(['pay-fcgo-voucher-online'])"
                    >
                      <v-icon small>mdi-credit-card</v-icon>
                    </v-btn>
                  </template>
                  <span>Card payment</span>
                </v-tooltip>
                <v-tooltip
                    top
                    v-if="!item.deleted_at && !paid && item.statusNumber === 48 && item.extra && item.extra.voucher_number"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                        @click="payThroughFCGO(item)"
                        class="ml-2"
                        color="green lighten-1"
                        dark
                        dense
                        fab
                        v-on="on"
                        x-small
                        v-if="$oauth.checkIfHasPermission(['pay-fcgo-voucher-online'])"
                    >
                      <v-icon medium>payments</v-icon>
                    </v-btn>
                  </template>
                  <span>Pay Online</span>
                </v-tooltip>

                <v-tooltip top
                           v-if="item.deletable && !item.deleted_at && !paid && editable  && !trekking && !transfer">
                  <template v-slot:activator="{ on }">
                    <v-btn
                        @click="deleteTrack(item)"
                        class="ml-2"
                        color="red lighten-1"
                        dark
                        dense
                        fab
                        v-on="on"
                        x-small
                        v-if="$oauth.checkIfHasPermission(['delete visa-visit-track'])"
                    >
                      <v-icon small>delete</v-icon>
                    </v-btn>

                  </template>
                  <span>Delete Track</span>
                </v-tooltip>

                <v-tooltip top v-if="item.deletable && !item.deleted_at && item.status == 'Paid' && !isVisaApproved">
                  <template v-slot:activator="{ on }">
                    <v-btn
                        @click="deleteTrack(item)"
                        class="ml-2"
                        color="red lighten-1"
                        dark
                        dense
                        fab
                        v-on="on"
                        x-small
                        v-if="$oauth.checkIfHasPermission(['delete paid-visa-track'])"
                    >
                      <v-icon small>delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Delete Paid Voucher</span>
                </v-tooltip>

                <v-tooltip top v-if="item.deletable && trekking && !item.deleted_at && !paid && editable">
                  <template v-slot:activator="{ on }">
                    <v-btn
                        @click="deleteTrekkingTrack(item)"
                        class="ml-2"
                        color="red lighten-1"
                        dark
                        dense
                        fab
                        v-on="on"
                        x-small
                        v-if="$oauth.checkIfHasPermission(['delete trekking-track'])"
                    >
                      <v-icon small>delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Delete Track</span>
                </v-tooltip>
                <v-tooltip top v-if="item.deletable && transfer && !item.deleted_at && !paid && editable">
                  <template v-slot:activator="{ on }">
                    <v-btn
                        @click="deleteTransferTrack(item)"
                        class="ml-2"
                        color="red lighten-1"
                        dark
                        dense
                        fab
                        v-on="on"
                        x-small
                        v-if="$oauth.checkIfHasPermission(['delete transfer-track'])"
                    >
                      <v-icon small>delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Delete Track</span>
                </v-tooltip>
                <v-tooltip top
                           v-if="item.statusNumber === 10 && assignedUser && !item.deleted_at &&  assignedUser.id === user.id && !isTippaniVerified">
                  <template v-slot:activator="{ on }">
                    <v-btn
                        @click="editTippani(item)"
                        class="ml-2"
                        color="blue lighten-1"
                        dark
                        dense
                        fab
                        v-on="on"
                        x-small
                        v-if="$oauth.checkIfHasPermission(['modify tippani-generated'])"
                    >
                      <v-icon small>edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit Tippani</span>
                </v-tooltip>
                <v-tooltip top v-if="(item.statusNumber === 11 || item.statusNumber === 12) && !item.deleted_at">
                  <template v-slot:activator="{ on }">
                    <v-btn
                        @click="editArrivalDepartureTrack(item)"
                        class="ml-2"
                        color="blue lighten-1"
                        dark
                        dense
                        fab
                        v-on="on"
                        x-small
                        v-if="$oauth.checkIfHasPermission(['modify arrival-departure-track'])"
                    >
                      <v-icon small>edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit Track</span>
                </v-tooltip>
                <v-tooltip top v-if="item.statusNumber === 31 && !item.deleted_at">
                  <template v-slot:activator="{ on }">
                    <v-btn
                        @click="attachDocument(item.id)"
                        class="float-right"
                        color="primary"
                        dark
                        dense
                        x-small>
                      Attach Documents
                    </v-btn>
                  </template>
                </v-tooltip>
                <v-btn
                    class="float-right"
                    color="red lighten-1"
                    dark
                    dense
                    text
                    v-if="item.deleted_at"
                    x-small>
                  Deleted at {{ item.deleted_at }}
                </v-btn>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        class="float-right bg-success text-white"
                        color="green lighten-1"
                        dark
                        dense
                        text
                        v-if="item.deleted_at  && item.statusNumber === 10"
                        @click="restoreTippaniItem(item)"
                        v-bind="attrs"
                        v-on="on"
                    >
                      <v-icon left size="25">mdi-backup-restore</v-icon>
                    </v-btn>
                  </template>
                  <span>Restore Tippani</span>
                </v-tooltip>

              </div>
            </v-flex>
          </v-layout>
          <v-layout style="color: black;">
            <component :cost="item.cost" :cost_npr="item.cost_npr" :item="item" :days="item.days" :extra="item.extra"
                       :user="item.user" v-bind:is="type(item.status)" :certification="certification"
                       :transfer="transfer"
                       :trekking="trekking"/>
          </v-layout>
        </v-timeline-item>
      </v-timeline>
    </v-card-text>
    <v-card-actions @click="loadMoreItem" style="justify-content: center" v-if="loadMore">
      <v-btn :loading="history_loading" color="primary" text>Load more</v-btn>
    </v-card-actions>
    <attach-file-dialog
        :url="'visa-visit-track/attach-file/'+trackId"
        @attached="getData"
        v-model="attachFileDialog"
    />
    <arrival-departure-track-edit-dialog v-if="arrivalDepartureTrack" :data="arrivalDepartureTrack"
                                         v-model="arrivalDepartureTrackEditModal"
                                         @edited="getData"></arrival-departure-track-edit-dialog>
    <v-dialog
        class="hide-on-print"
        persistent
        v-model="editTippaniDialog"
        width="800">
      <v-card class="hide-on-print">
        <v-toolbar color="blue darken-3" dark>
          <v-toolbar-title>Edit tippani</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-0">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-form class="pa-2" lazy-validation ref="formRef">
                  <v-layout row wrap>
                    <v-flex class="py-0" xs12>
                      <div id="editor" v-html="currentTippaniContent">

                      </div>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider style="margin-top:31px;"/>
        <v-card-actions>
          <v-spacer/>
          <v-btn @click="cancelEditTippaniDialog" class="white--text" color="red lighten-1">
            Cancel
          </v-btn>
          <v-btn
              :loading="loading"
              @click="saveTippani"
              class="white--text"
              color="blue darken-3"
          >Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import AttachFileDialog from "@/components/dialogs/AttachFileDialog";

const Applied = () => import('@/components/visa/history/Applied.vue');
const AppliedForConversion = () => import('@/components/visa/history/AppliedForConversion.vue');
const Paid = () => import('@/components/visa/history/Paid.vue');
const Approved = () => import('@/components/visa/history/Approved.vue');
const VisaNumberPrinted = () => import('@/components/visa/history/VisaNumberPrinted.vue');
const Arrived = () => import('@/components/visa/history/Arrived.vue');
const Departed = () => import('@/components/visa/history/Departed.vue');
const Deported = () => import('@/components/visa/history/Deported.vue');
const AppliedForVisaTransfer = () => import('@/components/visa/history/AppliedForVisaTransfer.vue');
const TippaniGenerated = () => import('@/components/visa/history/TippaniGenerated.vue');
const VisaTransferApproved = () => import('@/components/visa/history/VisaTransferApproved.vue');
const AppliedForExtend = () => import('@/components/visa/history/AppliedForExtend.vue');
const ConvertApproved = () => import('@/components/visa/history/ConvertApproved.vue');
const ExtendApproved = () => import('@/components/visa/history/ExtendApproved.vue');
const VisaCancelled = () => import('@/components/visa/history/VisaCancelled.vue');
const ArrivalCertificationApproved = () => import('@/components/visa/history/ArrivalCertificationApproved.vue');
const AppliedForArrivalCertification = () => import('@/components/visa/history/AppliedForArrivalCertification.vue');
const AppliedForDepartureCertification = () => import('@/components/visa/history/AppliedForDepartureCertification.vue');
const DepartureCertificationApproved = () => import('@/components/visa/history/DepartureCertificationApproved.vue');
const ArrivalCertificationRejected = () => import('@/components/visa/history/ArrivalCertificationRejected.vue');
const DepartureCertificationRejected = () => import('@/components/visa/history/DepartureCertificationRejected.vue');
const Offload = () => import('@/components/visa/history/Offload.vue');
const OffloadCancelled = () => import('@/components/visa/history/OffloadCancelled.vue');
const EntryRefuse = () => import('@/components/visa/history/EntryRefuse.vue');
const ArrivalCancelled = () => import('@/components/visa/history/ArrivalCancelled.vue');
const ArrivalReCancelled = () => import('@/components/visa/history/ArrivalReCancelled.vue');
const DepartureCancelled = () => import('@/components/visa/history/DepartureCancelled.vue');
const DepartureReCancelled = () => import('@/components/visa/history/DepartureReCancelled.vue');
const CostExempted = () => import('@/components/visa/history/CostExempted');
const ExpiryDateChanged = () => import('@/components/visa/history/ExpiryDateChanged');
const ProceededWithoutTippani = () => import('@/components/visa/history/ProceededWithoutTippani');
const Verified = () => import('@/components/visa/history/Verified');
const VoucherGenerated = () => import('@/components/visa/history/VoucherGenerated.vue');
const PenaltyApplied = () => import('@/components/visa/history/PenaltyApplied.vue');
const FileAttached = () => import('@/components/visa/history/FileAttached.vue');
const VisaInfoUpdated = () => import('@/components/visa/history/VisaInfoUpdated.vue');
const MuddhaEntry = () => import('@/components/visa/history/MuddhaEntry.vue');
const TravellerRegistered = () => import('@/components/visa/history/TravellerRegistered.vue');
const AppliedForPlanUpdate = () => import('@/components/visa/history/AppliedForPlanUpdate.vue');
const VisaPlanUpgradeApproved = () => import('@/components/visa/history/VisaPlanUpgradeApproved.vue');
const ManualVisaEntry = () => import('@/components/visa/history/ManualVisaEntry');
const VisaDocumentAttached = () => import('@/components/visa/history/VisaDocumentAttached');
const AppliedManually = () => import('@/components/visa/history/AppliedManually');
const ManualVisaApproved = () => import('@/components/visa/history/ManualVisaApproved');
const EmbassyVisaStart = () => import('@/components/visa/history/EmbassyVisaStart');
const ETAVisaStart = () => import('@/components/visa/history/ETAVisaStart');
const BorderPenaltyApplied = () => import('@/components/visa/history/BorderPenaltyApplied');
const SpecialCasePaymentVoucherGenerated = () => import('@/components/visa/history/SpecialCasePaymentVoucherGenerated');
const SpecialCasePaymentPaid = () => import('@/components/visa/history/SpecialCasePaymentPaid');
const VisaTransferredToNewPassport = () => import('@/components/visa/history/VisaTransferredToNewPassport')
const TrekkingPermit = () => import('@/components/visa/history/TrekkingPermit')
const AppliedForTrekkingPermit = () => import('@/components/visa/history/AppliedForTrekkingPermit')
const TrekkingRejected = () => import('@/components/visa/history/TrekkingRejected')
const TrekkingInfoUpdated = () => import('@/components/visa/history/TrekkingInfoUpdated')
const ReciprocityVisaPaid = () => import('@/components/visa/history/ReciprocityVisaPaid')
const ReciprocityVisaApproved = () => import('@/components/visa/history/ReciprocityVisaApproved')
const AttachmentFromDesktopApp = () => import('@/components/visa/history/AttachmentFromDesktopApp')
const TrekkingStickerNumberPrinted = () => import('@/components/visa/history/TrekkingStickerNumberPrinted.vue');
const RegulateThroughTouristVisaGenerated = () => import('@/components/visa/history/RegulateThroughTouristVisaGenerated.vue');
const TippaniVerified = () => import('@/components/visa/history/TippaniVerified.vue');
const TippaniApproved = () => import('@/components/visa/history/TippaniApproved.vue');
const PenaltyAcknowledged = () => import('@/components/visa/history/PenaltyAcknowledged.vue');

import {mapGetters} from "vuex";

import Http from 'axios';
import {BASE_TOKEN, VERSIONED_API_URL} from "../../../config/config";
import ArrivalDepartureTrackEditDialog from "../../../components/dialogs/ArrivalDepartureTrackEditDialog";
import {GET_VISA_TRANSFER} from "../../../store/action-type";
import FormErrorDisplayHandler from "@/components/FormErrorDisplayHandler";
import Quill from 'quill'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

export default {
  name: "VisaHistory",
  props: ['paid', 'history', 'show_load_more', 'editable', 'certification', 'trekking', 'transfer', 'assignedUser', 'isTippaniVerified', 'isVisaApproved','alldata'],
  data() {
    return {
      actions: [
        {
          key: 0,
          name: "Applied",
          statusColor: "blue",
          icon: "mdi-alpha-a-box"
        },
        {
          key: 1,
          name: "Paid",
          statusColor: "green",
          icon: "mdi-account-cash"
        },
        {
          key: 2,
          name: 'Approved',
          statusColor: "green",
          icon: "mdi-checkbox-multiple-marked-circle-outline"
        },
        {
          key: 6,
          name: 'Transferred',
          statusColor: "blue",
          icon: "mdi-alpha-t-box"
        },
        {
          key: 59,
          name: 'Visa Transferred To New Passport By Admin',
          statusColor: "blue",
          icon: "mdi-alpha-t-box"
        },
        {
          key: 7,
          name: 'Extend Approved',
          statusColor: "green",
          icon: "mdi-checkbox-multiple-marked-circle-outline"
        },
        {
          key: 8,
          name: 'Applied for Conversion',
          statusColor: "blue",
          icon: "mdi-alpha-a-box"
        },
        {
          key: 9,
          name: 'Applied for Extend',
          statusColor: "blue",
          icon: "mdi-alpha-a-box"
        },
        {
          key: 10,
          name: 'Tippani Generated',
          statusColor: "blue",
          icon: "mdi-check"
        },
        {
          key: 11,
          name: 'Arrived',
          statusColor: "blue",
          icon: "mdi-spellcheck"

        },
        {
          key: 12,
          name: 'Departed',
          statusColor: "blue",
          icon: "mdi-alpha-d-box"
        },
        {
          key: 16,
          name: 'Deported',
          statusColor: "red",
          icon: "mdi-spellcheck"
        },
        {
          key: 15,
          name: 'Convert approved',
          statusColor: "green",
          icon: "mdi-checkbox-multiple-marked-circle-outline"
        },
        {
          key: 20,
          name: 'Rejected',
          statusColor: "red",
          icon: "mdi-cancel"
        },
        {
          key: 21,
          name: 'Applied for Arrival Certification',
          statusColor: "blue",
          icon: "mdi-alert-octagon"
        },
        {
          key: 22,
          name: 'Applied for Departure Certification',
          statusColor: "blue",
          icon: "mdi-alert-octagon"
        },
        {
          key: 23,
          name: 'Applied for Visa Transfer',
          statusColor: "blue",
          icon: "mdi-alert-octagon"
        },
        {
          key: 24,
          name: 'Visa Transfer Approved',
          statusColor: "green",
          icon: "mdi-checkbox-multiple-marked-circle-outline"
        },
        {
          key: 25,
          name: 'Visa transfer rejected',
          statusColor: "blue",
          icon: "mdi-alert-octagon"
        },
        {
          key: 26,
          name: 'Arrival certification approved',
          statusColor: "green",
          icon: "mdi-checkbox-multiple-marked-circle-outline"
        },
        {
          key: 27,
          name: 'Arrival certification rejected',
          statusColor: "blue",
          icon: "mdi-alert-octagon"
        },
        {
          key: 28,
          name: 'Departure Certification Approved',
          statusColor: "blue",
          icon: "mdi-checkbox-multiple-marked-circle-outline"
        },
        {
          key: 29,
          name: 'Departure Certificiation Rejected',
          statusColor: "blue",
          icon: "mdi-alert-octagon"
        },
        {
          key: 30,
          name: 'Entry Refuse',
          statusColor: "red",
          icon: "mdi-circle-off-outline"
        },
        {
          key: 31,
          name: 'Offload',
          statusColor: "red",
          icon: "mdi-circle-off-outline"
        },
        {
          key: 32,
          name: 'Visa Cancelled',
          statusColor: "red",
          icon: "mdi-cancel"
        },
        {
          key: 35,
          name: 'Trekking Permit Taken',
          statusColor: "blue",
          icon: "mdi-check"
        },
        {
          key: 36,
          name: 'Trekking Permit Rejected',
          statusColor: "red",
          icon: "mdi-cancel"
        },
        {
          key: 40,
          name: 'Visa Cancelled',
          statusColor: "red",
          icon: "mdi-cancel"
        },
        {
          key: 41,
          name: 'Arrival Cancelled',
          statusColor: "red",
          icon: "mdi-cancel"
        }, {
          key: 42,
          name: 'Departure Cancelled',
          statusColor: "red",
          icon: "mdi-alert-octagon"
        }, {
          key: 43,
          name: 'Arrival Re-cancelled',
          statusColor: "green",
          icon: "mdi-cancel"
        },
        {
          key: 44,
          name: 'Departure Re-cancelled',
          statusColor: "green",
          icon: "mdi-check"
        },
        {
          key: 46,
          name: "Cost Exempted",
          statusColor: "green",
          icon: "mdi-cash-multiple"
        },
        {
          key: 47,
          name: 'Verified',
          statusColor: "green",
          icon: "mdi-check"
        },
        {
          key: 48,
          name: 'Voucher Generated',
          statusColor: "green",
          icon: "mdi-check"
        },
        {
          key: 49,
          name: 'Applied for plan update',
          statusColor: "green",
          icon: "mdi-check"
        },
        {
          key: 50,
          name: 'Visa plan upgrade approved',
          statusColor: "green",
          icon: "mdi-check"
        },
        {
          key: 51,
          name: 'Visa plan upgrade rejected',
          statusColor: "red",
          icon: "mdi-circle-off-outline"
        },
        {
          key: 52,
          name: 'Proceeded without tippani',
          statusColor: "orange",
          icon: "mdi-checkbox-multiple-marked-circle-outline"
        },
        {
          key: 53,
          name: 'Expiry Date Changed',
          statusColor: "orange",
          icon: "mdi-autorenew"
        },
        {
          key: 54,
          name: 'Penalty applied',
          statusColor: "orange",
          icon: "mdi-alpha-p"
        },
        {
          key: 55,
          name: 'Visa Info Updated',
          statusColor: "green",
          icon: "mdi-check-underline"
        },
        {
          key: 56,
          name: 'File attached',
          statusColor: "orange",
          icon: "mdi-file-cabinet"
        },
        {
          key: 57,
          name: 'Muddha Registered',
          statusColor: "orange",
          icon: "mdi-file-plus"
        },
        {
          key: 58,
          name: 'Muddha Registered',
          statusColor: "orange",
          icon: "mdi-file-plus"
        },
        {
          key: 60,
          name: 'Border Penalty -10(4) Applied',
          statusColor: "orange",
          icon: "mdi-alpha-b"
        },
        {
          key: 61,
          name: 'Manually Entered',
          statusColor: "orange",
          icon: "mdi-pencil"
        },
        {
          key: 62,
          name: 'Visa Document Attached',
          statusColor: "orange",
          icon: "mdi-plus"
        },
        {
          key: 63,
          name: 'Applied Manually',
          statusColor: "orange",
          icon: "mdi-alpha-a-box"
        },
        {
          key: 64,
          name: 'Manual Visa Approved',
          statusColor: "orange",
          icon: "mdi-checkbox-multiple-marked-circle-outline"
        },
        {
          key: 65,
          name: 'Embassy Visa Start',
          statusColor: "orange",
          icon: "mdi-plus"
        },
        {
          key: 66,
          name: 'Special Case Payment Voucher Generated',
          statusColor: "orange",
          icon: "mdi-plus"
        },
        {
          key: 67,
          name: 'Special Case Payment Paid',
          statusColor: "green",
          icon: "mdi-account-cash"
        },
        {
          key: 68,
          name: "Applied For Trekking Permit",
          statusColor: "blue",
          icon: "mdi-alpha-a-box"
        },
        {
          key: 69,
          name: "Offload Cancelled (Reload)",
          statusColor: "blue",
          icon: "mdi-airplane"
        },
        {
          key: 70,
          name: "Trekking Info Updated",
          statusColor: "blue",
          icon: "mdi-check-underline"
        },
        {
          key: 71,
          name: "Reciprocity Visa Paid",
          statusColor: "green",
          icon: "mdi-account-cash"
        },
        {
          key: 72,
          name: 'Reciprocity Visa Approved',
          statusColor: "green",
          icon: "mdi-checkbox-multiple-marked-circle-outline"
        },
        {
          key: 73,
          name: 'Attachment From Desktop App',
          statusColor: "green",
          icon: "mdi-file-cabinet"
        },
        {
          key: 74,
          name: 'Visa Sticker Printed',
          statusColor: "green",
          icon: "mdi-checkbox-multiple-marked-circle-outline"
        },
        {
          key: 75,
          name: 'Trekking Sticker Number Printed',
          statusColor: "green",
          icon: "mdi-checkbox-multiple-marked-circle-outline"
        },
        {
          key: 76,
          name: 'Trekking Permit Verified',
          statusColor: "green",
          icon: "mdi-check"
        },
        {
          key: 78,
          name: 'Visa Transfer Printed',
          statusColor: "green",
          icon: "mdi-checkbox-multiple-marked-circle-outline"
        },
        {
          key: 79,
          name: 'Visa Plan Upgrade Printed',
          statusColor: "green",
          icon: "mdi-checkbox-multiple-marked-circle-outline"
        },
        {
          key: 80,
          name: 'Tippani Verified',
          statusColor: "green",
          icon: "mdi-checkbox-multiple-marked-circle-outline"
        },
        {
          key: 81,
          name: '  Regulate through tourist visa generated',
          statusColor: "green",
          icon: "mdi-checkbox-multiple-marked-circle-outline"
        },
        {
          key: 84,
          name: 'Tippani Approved',
          statusColor: "green",
          icon: "mdi-checkbox-multiple-marked-circle-outline"
        },
        {
          key: 85,
          name: 'Penalty Acknowledged',
          statusColor: "green",
          icon: "mdi-signature-freehand"
        },
        {
          key: 86,
          name: 'eTA Visa Start',
          statusColor: "orange",
          icon: "mdi-plus"
        }
      ],
      hideDeletedStatus: ['Approved', 'Extend Approved', 'Convert Approved'],
      attachFileDialog: false,
      trackId: null,
      arrivalDepartureTrackEditModal: false,
      arrivalDepartureTrack: null,
      editTippaniDialog: false,
      currentTippani: null,
      currentTippaniContent: null,
      quill: false,
      loading: false
    }
  },
  components: {
    FormErrorDisplayHandler,
    ArrivalDepartureTrackEditDialog,
    AttachFileDialog,
    Applied,
    Paid,
    Approved,
    Arrived,
    Departed,
    Deported,
    Verified,
    AppliedForVisaTransfer,
    TippaniGenerated,
    VisaTransferApproved,
    AppliedForExtend,
    ConvertApproved,
    ExtendApproved,
    VisaCancelled,
    ArrivalCertificationApproved,
    AppliedForArrivalCertification,
    DepartureCertificationApproved,
    AppliedForDepartureCertification,
    ArrivalCertificationRejected,
    DepartureCertificationRejected,
    Offload,
    OffloadCancelled,
    EntryRefuse,
    ArrivalCancelled,
    ArrivalReCancelled,
    DepartureCancelled,
    DepartureReCancelled,
    CostExempted,
    ProceededWithoutTippani,
    ExpiryDateChanged,
    VoucherGenerated,
    FileAttached,
    PenaltyApplied,
    VisaInfoUpdated,
    AppliedForConversion,
    MuddhaEntry,
    TravellerRegistered,
    AppliedForPlanUpdate,
    ManualVisaEntry,
    VisaDocumentAttached,
    AppliedManually,
    ManualVisaApproved,
    EmbassyVisaStart,
    ETAVisaStart,
    BorderPenaltyApplied,
    VisaPlanUpgradeApproved,
    SpecialCasePaymentVoucherGenerated,
    SpecialCasePaymentPaid,
    VisaTransferredToNewPassport,
    TrekkingPermit,
    AppliedForTrekkingPermit,
    TrekkingRejected,
    TrekkingInfoUpdated,
    ReciprocityVisaApproved,
    ReciprocityVisaPaid,
    AttachmentFromDesktopApp,
    TrekkingStickerNumberPrinted,
    VisaNumberPrinted,
    RegulateThroughTouristVisaGenerated,
    TippaniVerified,
    TippaniApproved,
    PenaltyAcknowledged
  },
  methods: {
    type(status) {
      status = status.split(' ').join('-').toLowerCase();
      return status;
    },
    loadMoreItem() {
      this.$store.dispatch('TravellerSingle/getHistory', null)
    },
    getData() {
      this.$store.dispatch('TravellerSingle/getHistory', 'data')
    },
    view(submission_no) {
      window.location.href = '/admin/system/visa-requests/view/' + submission_no
    },
    getStatusColor(statusNumber) {
      const status = this.actions.find(i => i.key === statusNumber);
      if (status === undefined)
        return 'red';

      return status.statusColor;
    },
    getStatusName(statusNumber) {
      const status = this.actions.find(i => i.key === statusNumber);
      if (status === undefined)
        return 'Not defined';
      return status.name;
    },

    getPaymentSideText(item) {
      if (item.extra.source && item.extra.source.toLowerCase() == 'manual') {
        return "Paid Manually; Voucher Received by "
      } else if (item.extra.source && item.extra.source.toLowerCase() == 'malenika') {
        return "Paid from Malenika; Checked by "
      } else if (item.extra.source && item.extra.source.toLowerCase() == 'online') {
        return "Paid Online; Checked by "
      } else {
        return this.getStatusName(item.statusNumber)
      }
    },
    getIcon(statusNumber) {
      const status = this.actions.find(i => i.key === statusNumber);
      if (status === undefined)
        return 'mdi-user';
      return status.icon;
    },
    async deleteTrack(track) {
      await this.$dialog.confirm({
        text: "Are you sure?",
        title: "Warning",
        actions: {
          false: "No",
          true: {
            color: "red",
            text: "Yes",
            handle: () => {
              Http.delete(`${VERSIONED_API_URL}/visa-visit-track/${track.id}`)
                  .then((res) => {
                    this.$store.commit('Notification/showSuccess', "Track Deleted Successfully");
                    track.deleted_at = res.data.deleted_at;
                    this.$store.dispatch('VisaRequestSingle/getVisaRequestDetail', track.visa.submission_no)
                    if (!track.visa.submission_no)
                      this.$store.dispatch('VisaRequestSingle/getVisaRequestDetail', this.$route.params.id)
                  })
                  .catch(error => {
                    console.error(error);
                    this.$store.commit('Notification/showError', "Something went wrong");
                  });
            }
          }
        }
      });
    },
    async deleteTrekkingTrack(track) {
      await this.$dialog.confirm({
        text: "Are you sure?",
        title: "Warning",
        actions: {
          false: "No",
          true: {
            color: "red",
            text: "Yes",
            handle: () => {
              Http.delete(`${VERSIONED_API_URL}/trekking-track/${this.$route.params.id}/${track.statusNumber}`)
                  .then((res) => {
                    this.$store.commit('Notification/showSuccess', "Track Deleted Successfully");
                    track.deleted_at = res.data.deleted_at;
                    this.$store.dispatch('TrekkingSingle/getTrekkingRequestDetail', this.$route.params.id)
                  })
                  .catch(error => {
                    console.error(error);
                    this.$store.commit('Notification/showError', "Something went wrong");
                  });
            }
          }
        }
      });
    },
    async deleteTransferTrack(track) {
      await this.$dialog.confirm({
        text: "Are you sure?",
        title: "Warning",
        actions: {
          false: "No",
          true: {
            color: "red",
            text: "Yes",
            handle: () => {
              Http.delete(`${VERSIONED_API_URL}/visa-transfers/delete-track/${this.$route.params.id}/${track.statusNumber}`)
                  .then((res) => {
                    this.$store.commit('Notification/showSuccess', "Track Deleted Successfully");
                    track.deleted_at = res.data.deleted_at;
                    this.$store.dispatch(GET_VISA_TRANSFER, this.$route.params.id)
                  })
                  .catch(error => {
                    console.error(error);
                    this.$store.commit('Notification/showError', "Something went wrong");
                  });
            }
          }
        }
      });
    },
    async restoreTippaniItem(tippani) {
          console.log('tippani',tippani);
        await Http.post(`${VERSIONED_API_URL}/visa-transfers/restore-track/${tippani.id}`)
            .then((res) => {
              this.$store.commit('Notification/showSuccess', "Tippani Restored Successfully");
              this.$store.dispatch('VisaRequestSingle/getVisaRequestDetail', this.$route.params.id)
            })
            .catch(error => {
              console.error(error);
              this.$store.commit('Notification/showError', "Something went wrong");
            });
    },
    viewSCP(item) {
      this.$router.push({
        name: "ViewSCPDetail",
        params: {id: item.extra.submission_no}
      });
    },
    attachDocument(id) {
      this.attachFileDialog = true;
      this.trackId = id;
    },
    editArrivalDepartureTrack(item) {
      this.arrivalDepartureTrack = item;
      this.arrivalDepartureTrackEditModal = true;
    },
    editTippani(item) {
      this.editTippaniDialog = true;
      if (!this.quill) {
        setTimeout(() => {
          var container = document.getElementById('editor');
          this.quill = new Quill(container, {
            theme: 'snow',
            modules: {
              toolbar: [
                [{header: [1, 2, false]}],
                ['bold', 'italic', 'underline'],
              ],
            },
          });
        }, 200);
      }
      this.currentTippani = item
      this.currentTippaniContent = item.extra.content
    },
    saveTippani() {
      this.loading = true;
      Http.put(`${VERSIONED_API_URL}/visa-visit-track/update-tippani/${this.currentTippani.id}`, {content: this.quill.root.innerHTML})
          .then((res) => {
            this.$store.commit('Notification/showSuccess', "Tippani Updated Successfully");
            this.$store.dispatch('VisaRequestSingle/getVisaRequestDetail', this.$route.params.id)
            this.editTippaniDialog = false;
            this.loading = false;
          })
          .catch(error => {
            console.error(error);
            this.$store.commit('Notification/showError', "Something went wrong");
            this.loading = false;
          });
    },
    cancelEditTippaniDialog() {
      this.editTippaniDialog = false;
    },
    payThroughFCGO(item) {
      let params = {}
      if(this.certification){
        params = {
          code: item.voucher_number,
          token: item.voucher_token,
          sessionId: item.malanika_session_id,
          api_url: item.malanika_public_gateway
        }

      } else {
        params = {
          code: item.extra.voucher_number,
          token: item.extra.voucher_token,
          sessionId: item.extra.malanika_session_id,
          api_url: item.extra.malanika_public_gateway
        }
      }
      this.postToFCGO(params)
    },


    async testIPayment (item)  {
      console.log('item',this.alldata)
      try {
        const res = await Http.post(
            `${VERSIONED_API_URL}/iPayment`,
            {
              voucher_number: this.alldata.voucher_number,
            }
        );
        console.log('res',res.data.data.data)


        const formData = res.data.data.data.formData;
        const url =res.data.data.data.url;

        this.postToConnectIPS(url, formData);
      } catch (err) {
        console.error("ConnectIPS payment error", err);
        // notifyError(
        //     "Failed to initiate payment. Please try again later."
        // );
      }
    },

    postToConnectIPS (url, formData) {
      const form = document.createElement("form");
      form.method = "POST";
      form.action = url;

      // add hidden inputs from response
      Object.entries(formData).forEach(([key, value]) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = value;
        form.appendChild(input);
      });

      const newWindow = window.open("", "_blank", "width=1000,height=600,left=200,top=200");

      if (newWindow) {
        try {
          newWindow.focus();
          newWindow.document.body.appendChild(form);
          form.submit();
        } finally {
          newWindow.document.body.removeChild(form);
        }
      } else {
        alert("Please allow pop-ups to open the form in a new window.");
      }
    },

    createFcgoForm(data){
      const form = document.createElement("form");
      form.setAttribute("method", "POST");
      form.setAttribute("action", data.api_url);

      const params = {
        code: data.code,
        token: data.token,
        sessionId: data.sessionId,
        lang: "np",
      };

      Object.entries(params).forEach(([key, value]) => {
        const input = document.createElement("input");
        input.setAttribute("type", "text");
        input.setAttribute("name", key);
        input.setAttribute("value", value);
        form.appendChild(input);
      });

      return form;
    },
    postToFCGO(data) {
      const form = this.createFcgoForm(data);

      const newWindow = window.open(BASE_TOKEN, "_blank", "width=1000,height=600,left=200,top=200");

      if (newWindow) {
        try {
          newWindow.focus();
          newWindow.document.body.appendChild(form);
          form.submit();
        } finally {
          newWindow.document.body.removeChild(form);
        }
      } else {
        alert("Please allow pop-ups to open the form in a new window.");
      }
    },
  },
  computed: {
    ...mapGetters('TravellerSingle', ['history_loading', 'filters']),
    ...mapGetters("AuthUser", ["user"]),
    loadMore() {
      return (!!this.$store.state.TravellerSingle.next_page_url && this.show_load_more);
    },
    years() {
      let end = new Date().getFullYear();
      return Array(end - 2013).fill().map((_, idx) => 2014 + idx);
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.timeline-title {
  color: black;
}

.timeline-title-blue {
  color: dodgerblue;
}

</style>
